import { takeEvery, put, call, CallEffect, PutEffect } from "redux-saga/effects"

import { GET_AUTH_USER } from "./actionTypes"
import { getAuthUserOk, getAuthUserErr } from "./actions"

import {
  getAuthUser,
} from "~/helpers/backendHelper";
import type { GetUserResponse } from "~/types/backend";


/********** LOGIN **********/

function* onGetAuthUser(): Generator<CallEffect<GetUserResponse> | PutEffect<any>, void, GetUserResponse> {
  try {
    const response: GetUserResponse = yield call(getAuthUser);
    yield put(getAuthUserOk(response));
  } catch (error) {
    yield put(getAuthUserErr(error as Error));
  }
}

function* authSaga(): Generator {
  yield takeEvery(GET_AUTH_USER, onGetAuthUser);
}

export default authSaga;
